<template>
<div class="MReset m-login">
    <ResetRegister ref="resetRegister" @resetregister="_resetPwd">
        <template v-slot:btn>
            <van-button type="info" size="large" @click="resetPwd">修改密码</van-button>
        </template>
        <template v-slot:resetRegister>
            <router-link :to="{name: 'MRegister'}">注册账号</router-link>
        </template>
    </ResetRegister>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import ResetRegister from 'views/mobile/login/components/resetRegister'
import {resetPass} from 'api/api'
export default {
    name: 'MReset',
    data() {
        return {
            checked: false
        }
    },
    methods: {
        resetPwd() {
            this.$refs.resetRegister.ver()
        },
        _resetPwd(obj) {
            this.setLoading(true)
            resetPass({
                data: obj,
                success: () => {
                    this.setLoading(false)
                    this.$toast.success('修改成功')
                    this.$router.push({name: 'MLogin'})
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.mesg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {
        ResetRegister
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~views/mobile/login/login";
.MReset {
}
</style>